import {pick} from 'lodash'
import React, {useState, useContext} from 'react'
import {TeacherContext} from 'teacher/context'
import {faSearch} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import './search-pattern.styl'

const monitoringPath = (path) => `/:languageId/:role/monitoring/${path}`

export default function SearchPattern ({searchPlaceholder, initialPattern}) {
  const [pattern, setPattern] = useState(initialPattern || '')
  const context = useContext(TeacherContext)
  const {translate} = context
  const searchContext = pick(context, ['match','navigate', 'section', 'groupId'])
  return (
    <div className="pattern filter">
      <div className="wrapper">
        <FontAwesomeIcon icon={faSearch} />
        <input
          value={pattern}
          placeholder={searchPlaceholder}
          onChange={e => setPattern(e.target.value)}
          onKeyDown = {({key}) => key == 'Enter' && searchPattern({...searchContext, pattern})}
        /> 
        <span className="button" onClick={() => searchPattern({...searchContext, pattern})}>
          {translate("go_label")}
        </span>
      </div>
    </div>
  )
}

function searchPath ({match, section}) {
  return section == 'groups'
    ? monitoringPath('students')
    : match.path
}

function searchPattern(context) {
  const {navigate, pattern} = context
  const query = {
    pattern: pattern == '' ? undefined : pattern,
  }
  const path = searchPath(context)
  navigate({}, path, {preserveQuery: true, query})
}
